import { defineAction } from '~/prix'
import citizenCreateAction from './citizenCreate.action.json' with { type: 'json' }
import { citizenObject } from '../citizenObject'
import { z } from 'zod'

const citizenCreateDefinition = defineAction({
  ...citizenCreateAction,

  input: citizenObject.pick({
    id: true,
    residencesId: true,
    fullName: true,
    nickname: true,
    socialName: true,
    sex: true,
    cpf: true,
    cns: true,
    isResponsible: true,
    whatsapp: true,
    alternatePhone: true,
    fullAddress: true,
    complement: true,
    latitude: true,
    longitude: true,
    insertUserId: true,
    editUserId: true,
    observation: true,
    createdAt: true,
    updatedAt: true,
    synchronizedAt: true,
  }),
  output: z.object({}),
})

export default citizenCreateDefinition
